import { type Theme } from '@emotion/react';
import { Type } from '@silvertours/front-shared';
import { Breakpoint } from '../../rule';

export type IconRules = {
  color?: IconColor;
  indent?: 40 | 50;
  size?: IconSize | IconSizes;
};

export type IconType = Type.CarTypeIcon | Type.Icon;

export type IconSize = keyof Theme['spacing'] | 'full';

export type IconSizeForMedia = [size: IconSize, breakpoint?: Breakpoint];

export type IconSizes = Array<IconSizeForMedia>;

export type IconColor =
  'default' | 'green' | 'grey' | 'white' | 'orange' | 'error' | 'current';

const mapColor = (theme: Theme, color: IconColor = 'current') =>
  ({
    default: theme.colors.neutral.grey160,
    green: theme.colors.brand.green100,
    grey: theme.colors.neutral.grey140,
    white: theme.colors.neutral.white100,
    orange: theme.colors.brand.orange100,
    error: theme.colors.accent.red100,
    current: 'currentcolor',
  })[color];

export { mapColor };
